/* Beautify-inspired collapsible bars: animated max-height accordions,
   with nested rows inside each bar. */
(function () {
  if (window.ckBarsLoaded) return;
  window.ckBarsLoaded = true;

  var MOTION_OK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function expand(root, panel) {
    root.classList.add('is-open');
    var controls = root.querySelectorAll('[aria-controls="' + panel.id + '"]');
    controls.forEach(function (c) {
      c.setAttribute('aria-expanded', 'true');
    });
    if (!MOTION_OK || panel.scrollHeight === 0) {
      // Reduced motion, or unmeasurable (hidden ancestor): open instantly.
      panel.style.maxHeight = 'none';
      return;
    }
    panel.style.maxHeight = panel.scrollHeight + 'px';
    var done = function (event) {
      if (event.target !== panel) return;
      panel.removeEventListener('transitionend', done);
      if (root.classList.contains('is-open')) {
        // Let nested rows grow the parent freely once opened.
        panel.style.maxHeight = 'none';
      }
    };
    panel.addEventListener('transitionend', done);
  }

  function collapse(root, panel) {
    root.classList.remove('is-open');
    var controls = root.querySelectorAll('[aria-controls="' + panel.id + '"]');
    controls.forEach(function (c) {
      c.setAttribute('aria-expanded', 'false');
    });
    if (!MOTION_OK) {
      panel.style.maxHeight = '';
      return;
    }
    if (panel.style.maxHeight === 'none' || panel.style.maxHeight === '') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // Force a reflow so the browser registers the pixel height first.
      void panel.offsetHeight;
    }
    panel.style.maxHeight = '0px';
  }

  function grownParentOf(el, expandingPanel) {
    // If a nested row changes height while its parent bar panel has a pixel
    // max-height mid-transition, refresh the parent's target height. The
    // expanding row's panel is still near 0 tall when this runs, so add its
    // full content height to avoid undershooting (which would clip the row
    // until the parent's transitionend fires).
    var parentPanel = el.closest('.ck-bars__panel');
    if (parentPanel && parentPanel.style.maxHeight !== 'none' && parentPanel.style.maxHeight !== '0px' && parentPanel.style.maxHeight !== '') {
      var target = parentPanel.scrollHeight;
      if (expandingPanel) target += expandingPanel.scrollHeight;
      parentPanel.style.maxHeight = target + 'px';
    }
  }

  function initSection(section) {
    if (section.dataset.ckBarsInit === 'true') return;
    section.dataset.ckBarsInit = 'true';

    var singleRow = section.getAttribute('data-single-row') === 'true';

    section.querySelectorAll('[data-ck-bar-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = btn.closest('.ck-bars__bar');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!bar || !panel) return;
        if (bar.classList.contains('is-open')) {
          collapse(bar, panel);
        } else {
          expand(bar, panel);
        }
      });
    });

    section.querySelectorAll('[data-ck-row-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.ck-bars__row');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!row || !panel) return;
        if (row.classList.contains('is-open')) {
          collapse(row, panel);
          grownParentOf(row);
        } else {
          if (singleRow) {
            var grid = row.closest('.ck-bars__grid');
            if (grid) {
              grid.querySelectorAll('.ck-bars__row.is-open').forEach(function (open) {
                var openPanel = open.querySelector('.ck-bars__row-panel');
                if (openPanel) collapse(open, openPanel);
              });
            }
          }
          expand(row, panel);
          grownParentOf(row, panel);
        }
      });
    });

    // Bars marked open-by-default render with is-open; give their panels
    // a free height so content is visible without JS measurement.
    section.querySelectorAll('.ck-bars__bar.is-open > .ck-bars__inner > .ck-bars__panel').forEach(function (panel) {
      panel.style.maxHeight = 'none';
    });
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-ck-bars]');
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme editor: selecting any block reveals it.
  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest ? event.target.closest('[data-ck-bars]') : null;
    if (!section) return;
    var bar = event.target.closest('.ck-bars__bar') || event.target;
    if (bar.classList && bar.classList.contains('ck-bars__bar') && !bar.classList.contains('is-open')) {
      var barBtn = bar.querySelector('[data-ck-bar-toggle]');
      if (barBtn) barBtn.click();
    }
    var row = event.target.closest('.ck-bars__row');
    if (row && !row.classList.contains('is-open')) {
      var rowBtn = row.querySelector('[data-ck-row-toggle]');
      if (rowBtn) rowBtn.click();
    }
  });
})();
